import Vue from 'vue';
import Vuex from 'vuex';
import agent from './modules/agent';
import omni, { OmniState } from './modules/omni';
import $http from '@/utils/axios';
import wsGateway from '@/utils/websocketGateway';
import { isSuperAdmin, isTenantAdmin } from '@/common/permission';
import type { UserProfile } from '@/types/user';
import type { AgentState } from '@/types/agent';

Vue.use(Vuex);

export interface RootState {
  isLoggedIn: boolean;
  user: UserProfile | null;
  agent?: AgentState;
  omni?: OmniState;
}

export default new Vuex.Store<RootState>({
  state: {
    isLoggedIn: false,
    user: null
  },
  getters: {
    isLoggedIn: (state) => state.isLoggedIn,
    user: (state) => state.user,
    /** 是否为超级管理员（username === 'admin'） */
    isSuperAdmin: (state) => isSuperAdmin(state.user),
    /** 是否为租户管理员（角色为 tenantAdmin） */
    isTenantAdmin: (state) => isTenantAdmin(state.user)
  },
  mutations: {
    login(state, user: UserProfile & { token?: string }) {
      state.isLoggedIn = true;
      state.user = user;
      if (user.token) {
        localStorage.setItem('token', user.token);
      }
      wsGateway.resetAuth();
    },
    logout(state) {
      state.isLoggedIn = false;
      state.user = null;
      localStorage.removeItem('token');
      wsGateway.disconnect();
    }
  },
  actions: {
    login({ commit }, user) {
      commit('login', user);
    },
    logout({ commit }) {
      commit('logout');
    },
    /** 若本地有 token 但 store 无用户，则请求 /users/current 恢复登录状态（用于刷新后恢复） */
    async fetchCurrentUser({ commit, state }) {
      if (state.user) return state.user;
      const token = localStorage.getItem('token');
      if (!token) return null;
      try {
        const res: any = await $http.get('/users/current');
        commit('login', res.data);
        return res.data;
      } catch (e) {
        commit('logout');
        return null;
      }
    }
  },
  modules: {
    agent,
    omni
  }
});
